export const COLOR_PRESETS = [
	"#64748b",
	"#0058be",
	"#006c49",
	"#f59e0b",
	"#dc2626",
	"#7c3aed",
	"#0ea5e9",
	"#ec4899",
];

export function StageChip({ label, color }: { label: string; color: string }) {
	return (
		<span
			className="inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-xs font-medium"
			style={{
				backgroundColor: `${color}1a`,
				color,
				border: `1px solid ${color}33`,
			}}
		>
			<span
				className="h-2 w-2 rounded-full"
				style={{ backgroundColor: color }}
			/>
			{label}
		</span>
	);
}
